export default "__VITE_ASSET__CKeTidR6__"